import React from 'react';
import styles from './DesktopHeader.module.scss';
import TakeAwayLogo from '@assets/tkwylogo.svg';
import { NavLink } from 'react-router-dom';
import { globalStyles } from 'snacks-design-system';
import { useTranslation } from 'react-i18next';
import useFMFeatureFlag from '@src/shared/hooks/use-fm-featureflag';
import { JETFM_SHOW_NEW_DASHBOARD } from '@src/shared/models';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';
import DesktopHeaderTextNavLink from './components/DesktopHeaderTextNavLink';
import i18n, { languageQueryParam } from '@src/i18n';
import { IconLinkExternal } from '@justeattakeaway/pie-icons-react';
import HeaderNotificationIndicator from '../HeaderNotificationIndicator';
import UserLogo from '@src/shared/components/UserLogo';
import LanguageSelector from '@src/shared/components/LanguageSelector';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import { IHeaderVariantProps } from '../..';
import MCPMarketEnvironmentDetection from '@src/shared/utils/market-environment-detection';

const { xdsSpacingD } = globalStyles;

const DesktopHeader = ({
  fixed,
  loading,
  notificationCount,
  showUserPanel,
  showLanguageSelector,
  onShowNotificationMenu,
  onShowLanguageMenu,
  onShowUserMenu,
}: IHeaderVariantProps) => {
  const { t } = useTranslation();
  const showNewDashboard = useFMFeatureFlag(JETFM_SHOW_NEW_DASHBOARD);
  const { keycloakToken } = useKeycloakUserState();
  const isUserLoggedIn = !!keycloakToken;
  const marketEnvironment = MCPMarketEnvironmentDetection.getMarketEnvironment();
  const partnerHubURL = PARTNER_HUB_URLS[marketEnvironment.countryCode] || '';
  const renderLoggedInUserLinks = () => {
    return (
      <>
        <DesktopHeaderTextNavLink
          to={'/deliveries'}
          className={styles.navItem}
          activeClassName={styles.navItemActive}
        >
          {t('navigation.deliveries')}
        </DesktopHeaderTextNavLink>
        <DesktopHeaderTextNavLink
          to={'/couriers'}
          className={styles.navItem}
          activeClassName={styles.navItemActive}
        >
          {t('navigation.couriers')}
        </DesktopHeaderTextNavLink>

        {/*         {showNewDashboard && (
          <DesktopHeaderTextNavLink
            to={'/delivery-dashboard'}
            className={styles.navItem}
            activeClassName={styles.navItemActive}
          >
            {'New Delivery Dashboard'}
          </DesktopHeaderTextNavLink>
        )} */}

        {isUserLoggedIn && (
          <DesktopHeaderTextNavLink
            to={'/product-overview'}
            className={styles.navItem}
            activeClassName={styles.navItemActive}
            isActive={() =>
              location.pathname.includes('courier-overview') ||
              location.pathname.includes('product-overview')
            }
          >
            {t('mobile.product_overview')}
          </DesktopHeaderTextNavLink>
        )}
      </>
    );
  };

  const renderLoggedOutUserLinks = () => {
    return (
      <>
        <DesktopHeaderTextNavLink
          to={'/product-overview'}
          className={styles.navItem}
          activeClassName={styles.navItemActive}
        >
          {'Manager'}
        </DesktopHeaderTextNavLink>
        <DesktopHeaderTextNavLink
          to={'/courier-overview'}
          className={styles.navItem}
          activeClassName={styles.navItemActive}
        >
          {'Courier'}
        </DesktopHeaderTextNavLink>
      </>
    );
  };

  return (
    <div className={`${styles.PortalDesktopHeader} ${fixed ? 'fixed' : ''}`}>
      <NavLink to="/deliveries">
        <img src={TakeAwayLogo} className={styles.logo} />
      </NavLink>

      {isUserLoggedIn ? renderLoggedInUserLinks() : renderLoggedOutUserLinks()}

      <div className={styles.pushRight}></div>

      {isUserLoggedIn && (
        <DesktopHeaderTextNavLink
          to={`${partnerHubURL}/?${languageQueryParam}=${i18n.language}`}
          external={true}
          className={`${styles.navItem} ${styles.partnerhublink}`}
          activeClassName={styles.navItemActive}
        >
          {t('navigation.partner_hub')} <IconLinkExternal size={'s'} />
        </DesktopHeaderTextNavLink>
      )}

      {!isUserLoggedIn && (
        <DesktopHeaderTextNavLink
          to={'/deliveries'}
          external={true}
          className={`${styles.navItem} ${styles.partnerhublink}`}
          activeClassName={styles.navItemActive}
        >
          Courier Portal <IconLinkExternal size={'s'} />
        </DesktopHeaderTextNavLink>
      )}
      {isUserLoggedIn && (
        <PIEComponentUtil marginRight={xdsSpacingD}>
          <HeaderNotificationIndicator
            loading={loading}
            counter={notificationCount}
            onClick={onShowNotificationMenu}
          />
        </PIEComponentUtil>
      )}
      {showUserPanel && <UserLogo onClick={onShowUserMenu} />}
      {showLanguageSelector && (
        <LanguageSelector
          onClick={onShowLanguageMenu}
          toggleButtonClass={''}
          showToggleButton={true}
        />
      )}
    </div>
  );
};

export default DesktopHeader;
